import * as React from "react";
import { connect } from "react-redux";
import { actions as nameActions } from "src/actions/name.actions";
import { actions } from "src/actions/main.actions";
import { actions as homeActions } from "src/actions/home.actions";
import Icon from "src/core/ui/icon";
import ArtsDataService from "../arts.data.service";
import { resolve } from "inversify-react";
import { IApplicationState } from "../../../typings";

interface IFavouriteButtonProps {
    id: string;
}

type FavouriteButtonProps = IFavouriteButtonProps  & typeof actions & typeof homeActions;
interface IFavouriteButtonState {
    isFavourite: boolean;
}

class FavouriteButton extends React.Component<FavouriteButtonProps, IFavouriteButtonState> {

    @resolve
    public artsDataService: ArtsDataService;

    constructor(props: any) {
    super(props);
    this.state =  {
            isFavourite: false,
        };
    }

    public componentDidMount() {
        this.request();
    }

    public request = () => {
        this.artsDataService.getIsFavourite(this.props.id).then((result) => {
            this.setState({isFavourite: result});
        });
    }

    public setFavourite = (e) => {
        this.setState({ isFavourite: !this.state.isFavourite });

        if (e) {
            e.preventDefault();
        }

        if (this.state.isFavourite) {
            this.artsDataService.disableFavourite(this.props.id);
        } else {
            this.artsDataService.setFavourite(this.props.id);
        }
    }

    public render() {
        return (
            <div
                style={{cursor: "point"}}
                onClick={this.setFavourite}
                className={`iconified light action-icon`}>
                {this.state.isFavourite ?
                    <Icon type="love" style={{color: "#ff3663"}}/> : <Icon type="love"/>
                }
            </div>
        );
    }

}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return  {
        ...ownProps,
    };
}
export default connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(FavouriteButton);



// WEBPACK FOOTER //
// ./src/components/arts/parts/favourite.tsx